import clsx from "clsx";
import { DOC_SOURCE } from "constants/documents";
import { ReactComponent as WordIcon } from "icons/word.svg";
import { bool, func } from "prop-types";

import classes from "./DocumentSource.module.scss";

const AddInSourceCard = ({ isActive, onClick }) => {
  const onClickButton = (e) => {
    e.stopPropagation();
    onClick(DOC_SOURCE.ADDIN);
  };

  return (
    <button
      className={clsx(classes.card, isActive && classes.active)}
      onClick={onClickButton}
    >
      <WordIcon />
      <h4>Microsoft Word</h4>

      <p>
        Write directly in MS Word using the VisibleThread Add-in to create and
        score content.
      </p>
    </button>
  );
};

AddInSourceCard.propTypes = {
  isActive: bool,
  onClick: func.isRequired,
};

export default AddInSourceCard;
